module.exports = __webpack_public_path__ + "static/media/sip-calc.db34aa12.svg";